import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import NativeMoreNodeActionsMenu from './';

import './index.scss';

function NativeMoreNodeActionsMenuReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeMoreNodeActionsMenuReference = useRef(null);

  useEffect(function onLoad() {

    const nativeMoreNodeActionsMenu = new NativeMoreNodeActionsMenu({ ...props, positionMenu: props.positionToolbar });

    nativeMoreNodeActionsMenuReference.current = nativeMoreNodeActionsMenu;

    mount(wrapperMainReference.current, nativeMoreNodeActionsMenuReference.current);

    return uninitialize.bind(null, wrapperMainReference.current, nativeMoreNodeActionsMenuReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    if (props.activeNodePath === null) {
      return;
    }

    nativeMoreNodeActionsMenuReference.current.update({ ...props, positionMenu: props.positionToolbar });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  function uninitialize(mountPoint, element) {

    unmount(mountPoint, element);

  }

  function renderMain() {

    const mainAttributes = {
      className: 'more-actions-menu-native-react-wrapper-main hide-scrollbar',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeMoreNodeActionsMenuReactWrapper;